import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=f72250a4&scoped=true&"
import script from "./videoPlayer.vue?vue&type=script&lang=js&"
export * from "./videoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=f72250a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72250a4",
  null
  
)

export default component.exports